import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Calendar } from "lucide-react";
import { Button } from "../components/ui/button";
import SEOHead from "../components/SEOHead";

export const NotFoundPage = () => {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-4 text-center">
      <SEOHead
        title="Page Not Found | Empire Dance Kenya"
        description="The page you're looking for doesn't exist. Browse Empire Dance Kenya's classes, events and packages instead."
        noindex
      />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full"
      >
        {/* 404 number */}
        <div className="relative mb-6 select-none">
          <span className="text-[120px] md:text-[160px] font-black leading-none text-neutral-900">
            404
          </span>
          <span className="absolute inset-0 flex items-center justify-center text-[120px] md:text-[160px] font-black leading-none text-empire-gold opacity-10 blur-sm">
            404
          </span>
        </div>

        <h1 className="text-2xl md:text-3xl font-bold text-white mb-3">
          This move isn't in our routine
        </h1>
        <p className="text-neutral-400 mb-8">
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="btn-empire">
            <Link to="/">
              <Calendar className="w-4 h-4 mr-2" />
              View Schedule
            </Link>
          </Button>
          <Button asChild variant="outline" className="border-neutral-700 text-neutral-300 hover:bg-neutral-900">
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Link>
          </Button>
        </div>
      </motion.div>
    </div>
  );
};
